import React from 'react';

interface DeleteTrashIconProps {
    width?: number;
    height?: number;
    className?: string;
}

export const DeleteTrashIcon = ({ width = 24, height = 24, className = '' }: DeleteTrashIconProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 7.00749C3 6.4552 3.44772 6.00749 4 6.00749H20C20.5523 6.00749 21 6.4552 21 7.00749C21 7.55977 20.5523 8.00749 20 8.00749H4C3.44772 8.00749 3 7.55977 3 7.00749Z"
            fill="#B91C1C"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 9.99251C10.5523 9.99251 11 10.4402 11 10.9925V16.9925C11 17.5448 10.5523 17.9925 10 17.9925C9.44772 17.9925 9 17.5448 9 16.9925V10.9925C9 10.4402 9.44772 9.99251 10 9.99251Z"
            fill="#B91C1C"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 9.99251C14.5523 9.99251 15 10.4402 15 10.9925V16.9925C15 17.5448 14.5523 17.9925 14 17.9925C13.4477 17.9925 13 17.5448 13 16.9925V10.9925C13 10.4402 13.4477 9.99251 14 9.99251Z"
            fill="#B91C1C"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.91695 6.01094C5.46733 5.96508 5.95068 6.37406 5.99655 6.92444L6.99655 18.9244C6.99885 18.9521 7 18.9798 7 19.0075C7 19.2727 7.10536 19.5271 7.29289 19.7146C7.48043 19.9021 7.73478 20.0075 8 20.0075H16C16.2652 20.0075 16.5196 19.9021 16.7071 19.7146C16.8946 19.5271 17 19.2727 17 19.0075C17 18.9798 17.0012 18.9521 17.0035 18.9244L18.0035 6.92444C18.0493 6.37406 18.5327 5.96508 19.083 6.01094C19.6334 6.05681 20.0424 6.54016 19.9965 7.09053L18.9997 19.0533C18.9878 19.8324 18.6731 20.577 18.1213 21.1288C17.5587 21.6914 16.7957 22.0075 16 22.0075H8C7.20435 22.0075 6.44129 21.6914 5.87868 21.1288C5.32687 20.577 5.01223 19.8324 5.00035 19.0533L4.00345 7.09053C3.95759 6.54016 4.36658 6.05681 4.91695 6.01094Z"
            fill="#B91C1C"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V7C16 7.55228 15.5523 8 15 8C14.4477 8 14 7.55228 14 7V4H10V7C10 7.55228 9.55228 8 9 8C8.44772 8 8 7.55228 8 7V4C8 3.46957 8.21071 2.96086 8.58579 2.58579Z"
            fill="#B91C1C"
        />
    </svg>
);

